import settings from './img/assessment.svg'

const content = {
  pages: [
    {
      name: 'home',
      url: '/',
      title: 'Welcome to ESH',
      header: {
        title: 'Welcome to <b> ESH Alpha </b>',
        description: 'Lorem ipsum dolor sit amet consectetur. Facilisis auctor a diam cursus amet. Molestie metus morbi purus amet malesuada proin amet facilisis.',
        button: {
          label: 'contact us',
          url: '/contact',
        },
        img: '',
      },
      content: {
        title: '',
      },
      showMap: false,
      showContact: false,
      showServices: false,
      showContactInfo: false,
    },

  ],

  services: [
    {
      id: 1,
      mainTitle: 'Services',
      subTitle: 'For Business Solutions',
      description: 'Lorem ipsum dolor sit amet consectetur. Fames tempor enim molestie rutrum tempus dui arcu. Eu ultrices ut est ut adipiscing lorem. Proin nisi sollicitudin erat diam felis euismod vehicula sit.\n' +
        '\n' +
        '\n' +
        'Cras egestas sit faucibus nunc et. Enim vitae egestas arcu bibendum auctor in sed eget. Vulputate etiam quis lacus congue. Dapibus sed lacinia id enim dui aliquam purus faucibus. Eu lorem id sit ornare odio dictum sed dignissim.',
      button: {
        label: 'start',
        url: '',
      },
      img1: require('./img/service_img_big.svg'),
      img2: require('./img/service_img_small.svg'),
    },
    {
      id: 2,
      mainTitle: 'Services',
      subTitle: 'For Business Solutions',
      description: 'Lorem ipsum dolor sit amet consectetur. Fames tempor enim molestie rutrum tempus dui arcu. Eu ultrices ut est ut adipiscing lorem. Proin nisi sollicitudin erat diam felis euismod vehicula sit.\n' +
        '\n' +
        '\n' +
        'Cras egestas sit faucibus nunc et. Enim vitae egestas arcu bibendum auctor in sed eget. Vulputate etiam quis lacus congue. Dapibus sed lacinia id enim dui aliquam purus faucibus. Eu lorem id sit ornare odio dictum sed dignissim.',
      button: {
        label: 'start',
        url: '',
      },
      img1: require('./img/service_img_big.svg'),
      img2: require('./img/service_img_small.svg'),
    },
    {
      id: 3,
      mainTitle: 'Services',
      subTitle: 'For Business Solutions',
      description: 'Lorem ipsum dolor sit amet consectetur. Fames tempor enim molestie rutrum tempus dui arcu. Eu ultrices ut est ut adipiscing lorem. Proin nisi sollicitudin erat diam felis euismod vehicula sit.\n' +
        '\n' +
        '\n' +
        'Cras egestas sit faucibus nunc et. Enim vitae egestas arcu bibendum auctor in sed eget. Vulputate etiam quis lacus congue. Dapibus sed lacinia id enim dui aliquam purus faucibus. Eu lorem id sit ornare odio dictum sed dignissim.',
      button: {
        label: 'start',
        url: '',
      },
      img1: require('./img/service_img_big.svg'),
      img2: require('./img/service_img_small.svg'),
    },
    {
      id: 4,
      mainTitle: 'Services',
      subTitle: 'For Business Solutions',
      description: 'Lorem ipsum dolor sit amet consectetur. Fames tempor enim molestie rutrum tempus dui arcu. Eu ultrices ut est ut adipiscing lorem. Proin nisi sollicitudin erat diam felis euismod vehicula sit.\n' +
        '\n' +
        '\n' +
        'Cras egestas sit faucibus nunc et. Enim vitae egestas arcu bibendum auctor in sed eget. Vulputate etiam quis lacus congue. Dapibus sed lacinia id enim dui aliquam purus faucibus. Eu lorem id sit ornare odio dictum sed dignissim.',
      button: {
        label: 'start',
        url: '',
      },
      img1: require('./img/service_img_big.svg'),
      img2: require('./img/service_img_small.svg'),
    },
    // {
    //   id: 5,
    //   mainTitle: 'Services',
    //   subTitle: 'For Business Solutions',
    //   description: 'Lorem ipsum dolor sit amet consectetur. Fames tempor enim molestie rutrum tempus dui arcu. Eu ultrices ut est ut adipiscing lorem. Proin nisi sollicitudin erat diam felis euismod vehicula sit.\n' +
    //     '\n' +
    //     '\n' +
    //     'Cras egestas sit faucibus nunc et. Enim vitae egestas arcu bibendum auctor in sed eget. Vulputate etiam quis lacus congue. Dapibus sed lacinia id enim dui aliquam purus faucibus. Eu lorem id sit ornare odio dictum sed dignissim.',
    //   button: {
    //     label: 'start',
    //     url: '',
    //   },
    //   img1: require('./img/service_img_big.svg'),
    //   img2: require('./img/service_img_small.svg'),
    // },
  ],

  cards: [
    {
      id: 1,
      title: 'Lorem ipsum',
      description: 'Lorem ipsum dolor sit amet consectetur. Facilisis auctor a diam cursus amet.',
      img: './esh-alpha/static/media/settings.233a57cdd04c7793ae45490c2712573b.svg',
    },
    {
      id: 2,
      title: 'Lorem ipsum',
      description: 'Lorem ipsum dolor sit amet consectetur. Facilisis auctor a diam cursus amet.',
      img: './esh-alpha/static/media/account.4811f94e67eec06ba929ee65a40d26db.svg',
    },
    {
      id: 3,
      title: 'Lorem ipsum',
      description: 'Lorem ipsum dolor sit amet consectetur. Facilisis auctor a diam cursus amet.',
      img: './esh-alpha/static/media/assessment.6efc7aebe28b6ba0ef3024d96816b377.svg',
    },
    {
      id: 4,
      title: 'Lorem ipsum',
      description: 'Lorem ipsum dolor sit amet consectetur. Facilisis auctor a diam cursus amet.',
      img: './esh-alpha/static/media/settings.233a57cdd04c7793ae45490c2712573b.svg',
    },
    {
      id: 5,
      title: 'Lorem ipsum',
      description: 'Lorem ipsum dolor sit amet consectetur. Facilisis auctor a diam cursus amet.',
      img: './esh-alpha/static/media/account.4811f94e67eec06ba929ee65a40d26db.svg',
    },
    {
      id: 6,
      title: 'Lorem ipsum',
      description: 'Lorem ipsum dolor sit amet consectetur. Facilisis auctor a diam cursus amet.',
      img: './esh-alpha/static/media/assessment.6efc7aebe28b6ba0ef3024d96816b377.svg',
    },
  ]
}

export default content;
